.container {
  &:not(:first-child) {
    margin-top: 3.2rem;
  }
}

.card {
  background-color: rgba(255, 255, 255, 5%);
  border-radius: var(--border-radius-medium);
}

.header {
  padding: 0 1.6rem;
  height: 5.6rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.content {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 0.8rem;
  margin-right: 1.6rem;
  color: var(--color-grayscale-white);
}

.name {
  font-style: normal;
  line-height: 2.4rem;
  color: #e6edf3;
  margin-bottom: 1.6rem;
}

.footer {
  display: flex;
  align-items: center;
  border-top: solid 1px rgb(61, 68, 77);
  padding: 0 1.6rem;
  height: 5.6rem;
  font-size: 1.2rem;
  color: #9198a1;

  svg {
    color: #9198a1;
  }

  a {
    color: rgb(68, 147, 248);
  }
}
